module.exports = "/_next/static/images/image@2x-6391c5a4a5c58b54abd240f6ed469f9d.jpg";